import { Controller } from 'stimulus';

export default class extends Controller {
  switchTab(event) {
    const selectedMode = event.currentTarget.dataset.messageModeTab;

    this.element.querySelectorAll('[data-message-mode-tab]').forEach((tab) => {
      const isActive = tab.dataset.messageModeTab === selectedMode;
      tab.classList.toggle('border-themed-500', isActive);
      tab.classList.toggle('font-medium', isActive);
      tab.classList.toggle('border-transparent', !isActive);
    });

    this.element.querySelectorAll('[data-message-mode-panel]').forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.messageModePanel !== selectedMode);
    });

    // Disable required on fields inside hidden panels so browser validation doesn't block submit
    this.element.querySelectorAll('[data-message-mode-panel]').forEach((panel) => {
      const isVisible = panel.dataset.messageModePanel === selectedMode;
      panel.querySelectorAll('[required]').forEach((field) => {
        field.required = isVisible;
      });
    });

    const modeInput = this.element.querySelector('[data-message-mode-target="mode"]');
    if (modeInput) modeInput.value = selectedMode;
  }
}
